import { PERMISSION_SCOPES } from "components/layout/AccessControl";

import { PATHS } from "./routeConfig";

export const MenuTypes = {
  GROUP: "group",
  ITEM: "item",
  COLLAPSE: "collapse",
  COLLAPSE_LIST: "collapse-list",
};

export const MenuList = [
  {
    title: "Main",
    type: MenuTypes.GROUP,
    items: [
      {
        title: "Dashboard",
        type: MenuTypes.ITEM,
        badge: 4,
        badgeBg: "primary",
        badgeClassName: "badge-numeric",
        href: PATHS.DASHBOARD,
        icon: "inic inic-home",
        module: "Dashboard",
        permission: "View",
      },
      {
        title: "Users",
        type: MenuTypes.COLLAPSE,
        icon: "inic inic-person",
        module: ["Patients", "Admin User", "User"],
        permission: "View",
        eventKey: PATHS.USER,
        items: [
          {
            title: "App Users",
            type: MenuTypes.ITEM,
            href: `${PATHS.USER}/${PATHS.APP_USER}`,
            module: "User",
            permission: "View",
          },
          {
            title: "Admin Users",
            type: MenuTypes.ITEM,
            module: "Admin User",
            permission: "View",
            href: `${PATHS.USER}/${PATHS.ADMIN_USER}`,
          },
          {
            title: "Patients",
            type: MenuTypes.ITEM,
            href: `${PATHS.USER}/${PATHS.USER_LIST}`,
            module: "Patients",
            permission: "View",
          },
        ],
      },
      {
        title: "Static Pages",
        type: MenuTypes.ITEM,
        module: "Static Pages",
        permission: "View",
        href: `${PATHS.STATIC_PAGES}`,
        icon: "inic inic-website-content",
      },

      {
        title: "Roles & Permissions",
        type: MenuTypes.ITEM,
        module: "Role",
        permission: "View",
        href: PATHS.ROLE,
        badge: "New",
        badgeBg: "secondary",
        badgeClassName: "badge-text",
        icon: "inic inic-circle-tick",
      },
      {
        title: "Questionnaire",
        type: MenuTypes.ITEM,
        module: "Questionnaire",
        permission: "View",
        href: `${PATHS.QUESTIONNARIE}`,
        icon: "inic inic-website-content",
      },
      {
        title: "Wound Management",
        type: MenuTypes.ITEM,
        module: "Wound Management",
        permission: "View",
        href: PATHS.WOUND_LISTING,
        icon: "inic inic-all-inbox",
      },
    ],
  },
  {
    title: "General",
    type: MenuTypes.GROUP,
    items: [
      {
        title: "Email Templates",
        module: "Email Template",
        permission: "View",
        type: MenuTypes.ITEM,
        href: PATHS.EMAIL_TEMPLATES,
        icon: "inic inic-email",
        badge: 4,
        badgeBg: "primary",
        badgeClassName: "badge-numeric",
      },
      {
        title: "Master",
        module: [
          "Master Etiology",
          "Master Territory",
          "Master Professional Designation",
          "Page Title",
          "Not Assess Reasons",
        ],
        permission: "View",
        type: MenuTypes.COLLAPSE,
        icon: "inic inic-crown",
        eventKey: PATHS.MASTER_MANAGEMENT,
        items: [
          {
            title: "Etiology",
            module: "Master Etiology",
            permission: "View",
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.ETIOLOGY}`,
          },
          {
            title: "Territory",
            module: "Master Territory",
            permission: "View",
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.TERRITORY}`,
          },
          {
            title: "Professional Designation",
            module: "Master Professional Designation",
            permission: "View",
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.PROFESSIONAL_DESIGNATION}`,
          },
          {
            title: "Page Title",
            module: "Page Title",
            permission: "View",
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.PAGE_TITLE}`,
          },
          {
            title: "Non Assessment Reasons",
            module: "Not Assess Reasons",
            permission: "View",
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.NOT_ASSESS_REASON}`,
          },
        ],
      },
      // setting
      {
        title: "Settings",
        type: MenuTypes.COLLAPSE,
        icon: "inic inic-settings",
        module: ["General Settings", "SMTP Details"],
        permission: "View",
        eventKey: PATHS.SETTINGS,
        items: [
          {
            title: "General Settings",
            type: MenuTypes.ITEM,
            href: `${PATHS.SETTINGS}/${PATHS.GENERAL_SETTINGS}`,
            module: "General Settings",
            permission: "View",
          },

          {
            title: "SMTP Details",
            type: MenuTypes.ITEM,
            href: `${PATHS.SETTINGS}/${PATHS.SMTP_SMS_DETAILS}`,
            module: "SMTP Details",
            permission: "View",
          },
        ],
      },
    ],
  },
];
export const MenuListCollapsed = [
  {
    title: "Dashboard",
    module: "Dashboard",
    icon: "inic inic-home",
    href: PATHS.DASHBOARD,
    permission: "View",
  },
  {
    title: "Users",
    module: ["Patients", "Admin User", "User"],
    icon: "inic inic-person",
    href: PATHS.USER,
    permission: "View",
  },
  {
    title: "Static Pages",
    module: "Static Pages",
    permission: "View",
    icon: "inic inic-website-content",
    href: PATHS.STATIC_PAGES,
  },
  {
    title: "Roles & Permissions",
    module: "Role",
    href: PATHS.ROLE,
    icon: "inic inic-circle-tick",
    permission: "View",
  },
  {
    title: "Questionnaire",
    module: "Questionnaire",
    href: PATHS.QUESTIONNARIE,
    icon: "inic inic-website-content",
    permission: "View",
  },
  {
    title: "Wound Management",
    module: "Wound Management",
    href: PATHS.WOUND_LISTING,
    icon: "inic inic-all-inbox",
    permission: "View",
  },
  {
    title: "Email Templates",
    module: "Email Template",
    icon: "inic inic-email",
    href: PATHS.EMAIL_TEMPLATES,
    permission: "View",
  },
  {
    title: "Master",
    module: ["Master Etiology", "Master Territory", "Master Professional Designation", "Page Title"],
    icon: "inic inic-crown",
    href: PATHS.MASTER_MANAGEMENT,
    permission: "View",
  },
  {
    title: "General Settings",
    module: ["General Settings", "SMTP Details"],
    icon: "inic inic-settings",
    href: `${PATHS.SETTINGS}/${PATHS.GENERAL_SETTINGS}`,
    permission: "View",
  },
];
